/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';
import React, { useEffect } from 'react';
import { notificationService } from '../../api/services/notificationService';
import { setheaderNotifData } from '../../infra/aggregates/NotificationSlice';
import { useAppDispatch, useAppSelector } from '../../infra/hooks';
interface PropsValues {
  setNotificationData: (data: any) => void;
  settextFilter: any;
}

function DTONotification({ setNotificationData, settextFilter }: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);
  const dispatch = useAppDispatch();
  async function getNotificationList(
    userId: number,
    companyId: number,
    empId: number,
  ) {
    const response: any = await notificationService.getAllEmpNotifications(
      userId,
      companyId,
      empId,
    );
    if (response.response == 'success') {
      dispatch(setheaderNotifData(response?.data?.data));

      const annList = () => {
        if (settextFilter.length) {
          const txt = settextFilter.toLowerCase();
          const res = _.filter(response?.data?.data, function (e: any) {
            return e.type?.toLowerCase().includes(txt);
          });
          {
            return res;
          }
        } else {
          return response?.data?.data;
        }
      };

      const notifDataList: any = _.map(annList(), (data: any) => {
        const rowData: any = {
          id: data?.id,
          date: data?.created_at,
          content: data?.type,
          message: data?.notifiable_type,
          attachment: data?.attachments,
          status: data?.status,
          datafrom: data?.datafrom,
          readat: data?.read_at,
          subject: data?.subject,
        };
        return rowData;
      });

      setNotificationData(notifDataList);
    }
  }
  useEffect(() => {
    if (selector.user_id && selector.company_id)
      getNotificationList(
        selector.user_id,
        selector.company_id,
        selector.emp_id,
      );
  }, []);

  useEffect(() => {
    getNotificationList(selector.user_id, selector.company_id, selector.emp_id);
  }, [settextFilter.length]);

  return <></>;
}
export default DTONotification;
